import _get from "lodash.get";
import { getStorageData } from "@/utils/storage";

const STORAGE_SYSTEM_KEY = "system";

const isSameRevision = () => {
    const system = getStorageData(STORAGE_SYSTEM_KEY);
    const systemRevision = _get(system, "revision");
    return process.env.VUE_APP_REVISION === systemRevision;
};

export default isSameRevision;
